module.exports = {"230622100":"肇源镇","230622101":"三站镇","230622102":"二站镇","230622103":"茂兴镇","230622104":"古龙镇","230622105":"新站镇","230622106":"头台镇","230622107":"古恰镇","230622200":"福兴乡","230622201":"薄荷台乡","230622203":"和平乡","230622207":"超等乡","230622208":"民意乡","230622210":"义顺乡","230622211":"浩德乡","230622212":"大兴乡","230622500":"肇源农场","230622581":"种畜场","230622583":"新立良种繁育场","230622584":"立陡山良种场","230622586":"果树示范场","230622587":"经济作物示范场","230622588":"茂兴湖水产养殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230622.json
// module id = 737
// module chunks = 0